import { Outlet } from 'react-router-dom';
import { useAppLocation } from 'services/navigation/use-location';
import { useProfileRole } from 'common/use-profile-role';
import { PageProtectorBase } from './Base/PageProtectorBase';

export const ManagerPageProtector = () => {
  const location = useAppLocation();
  const { isManager } = useProfileRole();

  return (
    <PageProtectorBase to={'/page-not-found'} condition={isManager} state={{ from: location }}>
      <Outlet />
    </PageProtectorBase>
  );
};
